export enum DateNavigation {
  NEXT,
  PREVIOUS,
  RESET
}
